import { DeepPartial, Raw } from '@/modules/common/helpers/api';
import { CollateralType, SettlementType } from '@/connect';

export type RawAgreementInfo = Raw<AgreementInfo>;

export class AgreementInfo {
  public id: string;
  public shortName: string;
  public counterpartyId?: string;
  public collateralType?: CollateralType;
  public settlementType?: SettlementType;

  protected constructor(data: RawAgreementInfo) {
    this.id = data.id;
    this.shortName = data.shortName;
    this.counterpartyId = data.counterpartyId;
    this.collateralType = data.collateralType;
    this.settlementType = data.settlementType;
  }

  public static fromData(data: RawAgreementInfo): AgreementInfo {
    return new AgreementInfo(data);
  }

  public static toData(model: AgreementInfo): RawAgreementInfo {
    return {
      id: model.id,
      shortName: model.shortName,
      counterpartyId: model.counterpartyId,
      collateralType: model.collateralType,
      settlementType: model.settlementType,
    };
  }

  public static mock(data?: null | DeepPartial<RawAgreementInfo>): AgreementInfo {
    return AgreementInfo.fromData(AgreementInfo.mockData(data));
  }

  public static mockData(data?: null | DeepPartial<RawAgreementInfo>): RawAgreementInfo {
    return {
      id: 'RV3QE2RV',
      shortName: 'Super awesome agreement',
      counterpartyId: '1234567890',
      collateralType: CollateralType.CASH,
      settlementType: SettlementType.BILATERAL,
      ...data,
    };
  }
}
